import { useMutation , useInfiniteQuery} from "react-query";
import { queryClient } from "../../libs/react-query";
import { GET_INFINITE_USER_DELETE_REQUEST } from "../../constants/queryKeys";
import { addUserDeleteRequest, getInfiniteUserDeleteRequest, updateStatusUserDeleteRequest } from "../apiClient/userDeleteFrom";


const invalidateUserDeleteRequestQuery = () => {
	queryClient.invalidateQueries(GET_INFINITE_USER_DELETE_REQUEST);
};

const useInfiniteFetchUserDeleteRequest = ({ payload, config }) => {
	return useInfiniteQuery( [GET_INFINITE_USER_DELETE_REQUEST, payload], getInfiniteUserDeleteRequest, config );
};

const useAddUserDeleteRequest = (options) => {
	return useMutation((payload) => addUserDeleteRequest(payload), options);
};

const useUpdateStatusUserDeleteRequest = (options) => {
	return useMutation((payload) => updateStatusUserDeleteRequest(payload), options);
};

export { invalidateUserDeleteRequestQuery, useInfiniteFetchUserDeleteRequest, useAddUserDeleteRequest, useUpdateStatusUserDeleteRequest };
